module.exports = __webpack_public_path__ + "static/media/DSC_9885.9f12baca.jpg";